/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/activateVip",
      name: "activateVip",
      component: () => import("../dsf/activateVip.vue"),
    },
    // 登录
    {
      path: "/",
      name: "Login",
      component: () => import("@/login"),
    },
    //--------销售部--------
    {
      path: "/sellwork",
      name: "SellWork",
      component: () => import("@/sell/layout"),
      redirect: "/sellwork/sellmes/sellpersonMes",
      children: [
        {
          path: "sellmes",
          name: "SellMes",
          component: () => import("@/sell/views/message"),
          meta: {
            navName: "日常信息",
            keys: "1",
            isBoos: true,
            isBorther: true,
            BGI: require("../assets/image/DailyInformation.png"),
          },
          children: [
            {
              path: "sellpersonMes",
              name: "SellPersonMes",
              component: () => import("@/sell/views/message/child/personMes"),
              meta: {
                navName: "个人信息",
                keys: "1-1",
                isBoos: true,
                isBorther: true,
                BGI: require("../assets/image/personalInformation.png"),
              },
            },
          ],
        },
        {
          path: "/sellWorkTool",
          name: "SellWorkTool",
          component: () => import("@/sell/views/workTool"),
          meta: {
            isBorther: true,
            navName: "销售工具",
            keys: "2",
            BGI: require("../assets/image/Forensictools.png"),
          },
          children: [
            {
              path: "sellMyUser",
              name: "SellMyUser",
              component: () => import("@/sell/views/message/child/myUser"),
              meta: {
                navName: "查询客户",
                keys: "2-1",
                isBoos: true,
                isBorther: true,
                BGI: require("../assets/image/user.png"),
              },
            },
            {
              path: "sellMyChannel",
              name: "SellMyChannel",
              component: () => import("@/sell/views/message/child/myChannel"),
              meta: {
                navName: "查询渠道商",
                keys: "2-2",
                isBoos: true,
                isBorther: false,
                BGI: require("../assets/image/user.png"),
              },
            },
          ],
        },
      ],
    },
    // 工作台
    {
      path: "/work",
      name: "Work",
      component: () => import("@/layout"),
      redirect: "/work/mes/personMes",
      children: [
        {
          path: "mes",
          name: "Mes",
          component: () => import("@/views/message"),
          meta: {
            navName: "日常信息",
            keys: "1",
            isBoos: true,
            isBorther: true,
            BGI: require("../assets/image/DailyInformation.png"),
          },
          children: [
            {
              path: "personMes",
              name: "PersonMes",
              component: () => import("@/views/message/child/personMes"),
              meta: {
                navName: "个人信息",
                keys: "1-1",
                isBoos: true,
                isBorther: true,
                BGI: require("../assets/image/personalInformation.png"),
              },
            },
            {
              path: "myLawyer",
              name: "MyLawyer",
              component: () => import("@/views/message/child/myLawyer"),
              meta: {
                navName: "我的律师",
                keys: "1-2",
                isBorther: true,
                BGI: require("../assets/image/solicitor.png"),
              },
            },
            {
              path: "myMes",
              name: "MyMes",
              component: () => import("@/views/message/child/myMes"),
              meta: {
                navName: "我的消息",
                keys: "1-3",
                isBorther: true,
                BGI: require("../assets/image/information.png"),
              },
            },
            {
              path: "myUser",
              name: "myUser",
              component: () => import("@/views/message/child/myUser"),
              meta: {
                navName: "我的用户",
                keys: "1-4",
                isBoos: true,
                isBorther: true,
                BGI: require("../assets/image/user.png"),
              },
            },
            {
              path: "userLeaveWord",
              name: "UserLeaveWord",
              component: () => import("@/views/message/child/userLeaveWord"),
              meta: {
                navName: "客户留言",
                keys: "1-5",
                isBorther: true,
                BGI: require("../assets/image/voiceMessage.png"),
              },
            },
            {
              path: "VIPOrder",
              name: "VipOrder",
              component: () => import("@/views/message/child/VIPOrder"),
              meta: {
                navName: "VIP订单",
                keys: "1-6",
                isBorther: true,
                BGI: require("../assets/image/VIPOrder.png"),
              },
            },
            {
              path: "workCourse",
              name: "WorkCourse",
              component: () => import("@/views/message/child/workCourse"),
              meta: {
                navName: "工作进程",
                keys: "1-7",
                isBorther: true,
                BGI: require("../assets/image/progressOfWork.png"),
              },
              children: [
                {
                  path: "newOrder",
                  name: "NewOrder",
                  component: () =>
                    import("@/views/message/child/workCourse/child/newOrder"),
                  meta: {
                    navName: "新订单",
                    keys: "1-7-1",
                    isBorther: true,
                    BGI: require("../assets/image/newOrder.png"),
                  },
                },
                {
                  path: "marchOrder",
                  name: "MarchOrder",
                  component: () =>
                    import("@/views/message/child/workCourse/child/marchOrder"),
                  meta: {
                    navName: "服务中订单",
                    keys: "1-7-2",
                    isBorther: true,
                    BGI: require("../assets/image/In-serviceOrder.png"),
                  },
                },
                {
                  path: "doneOrder",
                  name: "DoneOrder",
                  component: () =>
                    import("@/views/message/child/workCourse/child/doneOrder"),
                  meta: {
                    navName: "已完成订单",
                    keys: "1-7-3",
                    isBorther: true,
                    BGI: require("../assets/image/finishOrder.png"),
                  },
                },
                {
                  path: "canceledOrder",
                  name: "CanceledOrder",
                  component: () =>
                    import(
                      "@/views/message/child/workCourse/child/canceledOrder"
                    ),
                  meta: {
                    navName: "被取消订单",
                    keys: "1-7-4",
                    isBorther: true,
                    BGI: require("../assets/image/cannerOrder.png"),
                  },
                },
              ],
            },
            // isBoos表示只有符合账号能访问到的页面
            {
              path: "contract",
              name: "Contract",
              component: () => import("@/views/message/child/contract"),
              meta: {
                navName: "合同复核",
                keys: "1-8",
                isBoos: true,
                BGI: require("../assets/image/progressOfWork.png"),
              },
              children: [
                {
                  path: "newContract",
                  name: "NewContract",
                  component: () =>
                    import("@/views/message/child/contract/newContract"),
                  meta: {
                    navName: "新订单",
                    keys: "1-8-1",
                    isBoos: true,
                    BGI: require("../assets/image/newOrder.png"),
                  },
                },
                {
                  path: "marchContract",
                  name: "MarchContract",
                  component: () =>
                    import("@/views/message/child/contract/marchContract"),
                  meta: {
                    navName: "服务中订单",
                    keys: "1-8-2",
                    isBoos: true,
                    BGI: require("../assets/image/In-serviceOrder.png"),
                  },
                },
                {
                  path: "doneContract",
                  name: "DoneContract",
                  component: () =>
                    import("@/views/message/child/contract/doneContract"),
                  meta: {
                    navName: "已完成订单",
                    keys: "1-8-3",
                    isBoos: true,
                    BGI: require("../assets/image/finishOrder.png"),
                  },
                },
                {
                  path: "cancelContract",
                  name: "CancelContract",
                  component: () =>
                    import("@/views/message/child/contract/cancelContract"),
                  meta: {
                    navName: "被取消订单",
                    keys: "1-8-4",
                    isBoos: true,
                    BGI: require("../assets/image/cannerOrder.png"),
                  },
                },
                {
                  path: "newUserContract",
                  name: "NewUserContract",
                  component: () =>
                    import("@/views/message/child/contract/newUserContract"),
                  meta: {
                    navName: "新增用户",
                    keys: "1-8-5",
                    isBoos: true,
                    BGI: require("../assets/image/user.png"),
                  },
                },
                // 后续加的，客户开通VIP
                {
                  path: "activateVip",
                  name: "activateVip",
                  component: () => import("../dsf/activateVip.vue"),
                  meta: {
                    navName: "集团开通",
                    keys: "1-8-7",
                    isBoos: true,
                    BGI: require("../assets/image/personalInformation.png"),
                  },
                },
                // {
                //   path: 'allContract',
                //   name: 'AllContract',
                //   component: () => import(
                //     '@/views/message/child/contract/allContract'),
                //   meta: {
                //     navName: '全部订单',
                //     keys: '1-8-6',
                //     isBoos: true,
                //     BGI: require('../assets/image/allorder.png')
                //   }
                // }
              ],
            },
            {
              path: "reCheck",
              name: "ReCheck",
              component: () => import("@/views/message/child/reCheck"),
              meta: {
                navName: "待复核订单",
                keys: "1-12",
                isBoos: true,
                BGI: require("../assets/image/reCheck.png"),
              },
            },
            {
              path: "BoosUserMsg",
              name: "BoosUserMsg",
              component: () => import("@/views/message/child/BoosUserMsg"),
              meta: {
                navName: "审核取消",
                keys: "1-9",
                isBoos: true,
                BGI: require("../assets/image/cannerOrder.png"),
              },
            },
            {
              path: "userActive",
              name: "UserActive",
              component: () => import("@/views/message/child/userActive"),
              meta: {
                navName: "用户活跃度",
                keys: "1-11",
                isBorther: true,
                BGI: require("../assets/image/active.png"),
              },
            },
            {
              path: "aiReview",
              name: "AiReview",
              component: () =>
                import("@/views/message/child/components/AiReview.vue"),
              meta: {
                title: "AI审查",
              },
            },
          ],
        },
        {
          path: "comment",
          name: "comment",
          component: () => import("@/views/message/child/comment"),
          meta: {
            navName: "客户评价",
            keys: "1-10",
            isBorther: true,
            BGI: require("../assets/image/evaluate.png"),
          },
        },
        {
          path: "/workTool",
          name: "WorkTool",
          component: () => import("@/views/workTool"),
          meta: {
            isBorther: true,
            navName: "法务工具",
            keys: "2",
            BGI: require("../assets/image/Forensictools.png"),
          },
          children: [
            {
              isBorther: true,
              path: "library",
              name: "Library",
              component: () => import("@/views/workTool/child/library"),
              meta: {
                navName: "行业合同库查询",
                keys: "2-1",
                isBoos: true,
                isBorther: true,
                BGI: require("../assets/image/standard.png"),
              },
            },
            {
              path: "normLibrary",
              name: "NormLibrary",
              component: () => import("@/views/workTool/child/library"),
              meta: {
                navName: "标准合同库查询",
                keys: "2-2",
                isBoos: true,
                isBorther: true,
                BGI: require("../assets/image/standard.png"),
              },
            },
          ],
        },
        {
          path: "/tripartite",
          name: "Tripartite",
          component: () => import("@/views/tripartiteTalks"),
          meta: {
            navName: "三方会议",
            keys: "3",
            BGI: require("../assets/image/tripartiteConference.png"),
          },
        },
        {
          path: "/serviceSystem",
          name: "ServiceSystem",
          component: () => import("@/views/serviceSystem"),
          meta: {
            navName: "客服系统",
            keys: "4",
            BGI: require("../assets/image/service.png"),
          },
        },
        // {
        //   path: "/ai",
        //   name: "ai",
        //   component: () => import("@/views/Ai"),
        //   meta: {
        //     navName: "Deep Seek",
        //     keys: "5",
        //     BGI: require("../assets/image/deepseek.png"),
        //   },
        // },
        // {
        //   path: "/ceshi",
        //   name: "ceshi",
        //   component: () => import("@/views/Ai/ceshi"),
        //   meta: {
        //     navName: "Deep Seek",
        //     keys: "6",
        //     BGI: require("../assets/image/deepseek.png"),
        //   },
        // },
        {
          path: "/Ai",
          name: "Ai",
          component: () => import("@/views/Ai"),
          meta: {
            // navName: "Deep Seek",
            navName: "智能助手",
            keys: "6",
            BGI: require("../assets/image/zhushou.png"),
          },
          children: [
            {
              path: "QiCao",
              name: "QiCao",
              component: () => import("@/views/Ai/QiCao.vue"),
              meta: {
                navName: "文书起草",
                keys: "6-1",
                isBorther: true,
                BGI: require("../assets/image/qicao.png"),
              },
            },
            {
              path: "ShenCha",
              name: "ShenCha",
              component: () => import("@/views/Ai/ShenCha.vue"),
              meta: {
                navName: "合同审查",
                keys: "6-2",
                isBorther: true,
                BGI: require("../assets/image/shencha.png"),
              },
            },
          ],
        },
        // 我的用户详情页
        {
          path: "/myUserListCompany",
          name: "MyUserListCompany",
          component: () =>
            import("@/views/message/child/components/MyUserListCompany"),
          meta: {
            other: true,
          },
        },
        //销售部查找用户详情页面
        {
          path: "/sellMyUserListCompany",
          name: "SellMyUserListCompany",
          component: () =>
            import("@/sell/views/message/child/components/MyUserListCompany"),
          meta: {
            other: true,
          },
        },
        {
          path: "/orderDetails",
          name: "OrderDetails",
          component: () =>
            import("@/views/message/child/components/orderDetails"),
          meta: {
            other: true,
          },
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js